












































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { bus } from "../../main";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import * as temp from "../../_store/temp.module";
import DetailsDialog from "../Dialogs/DetailsDialog.vue";
import EditDialog from "../Edit/EditDialog.vue";
import CreateDialog from "../Dialogs/CreateDialog.vue";

@Component({
  components: {
    DetailsDialog,
    EditDialog,
    CreateDialog
  }
})
export default class ActivityDataTable extends Vue {
  @Prop() params!: any;
  @Prop() createDialogParams!: any;

  private anniScolastici: any[];
  private tipoAttivita: any[];

  private annoScolasticoFilter: any;
  private tipoAttivitaFilter: any;

  private search: string;
  private loadingData: boolean;

  constructor() {
    super();
    this.search = "";
    this.loadingData = true;
    this.annoScolasticoFilter = 0;
    this.anniScolastici = [];
    this.tipoAttivita = ["Tutti","Tirocini Estivi","Tirocini Formativi","Tirocini Re/Inserimento","FSL","Workshop","Colloqui CV"]
    this.tipoAttivitaFilter = "Tutti";
  }

  @Watch("annoScolasticoFilter")
  onAnnoScolasticoChange(value: string) {
    this.loadingData = true
    this.changeAnnoScolastico();
    // bus.$emit("autorizzazioneFilter", value)
  }

  @Watch("tipoAttivitaFilter")
  onTipoAttivtaChange(value: string) {
    this.filterChange();
    // bus.$emit("autorizzazioneFilter", value)
  }

  filterChange() {
    var filters = {
      filtroAutorizzazione: "Tutti",
      filtroAnni: "",
      filtroDocResp: "",
      fitroArticolazione: "",
      filtroSezione: "",
      filtroTipoAttivita: ""
    };
    if (this.params.filterType === "listaAttivita") {
      filters = {
        filtroAutorizzazione: "",
        filtroAnni: "",
        filtroDocResp: "",
        fitroArticolazione: "",
        filtroSezione: "",
        filtroTipoAttivita: this.tipoAttivitaFilter
      };
      bus.$emit("filtroAttivita", filters);
    }
  }

  modificaIscrizione(value: any, attività: any) {
    var message: string = "";
    var payload = {
      idAttivita: attività.idAttivita,
      statoIscrizione: value
    };
    if (value === true) {
      message = "Si desidera aprire il periodo di iscrizione per l'attività?";
    } else {
      message = "Si desidera chiudere il periodo di iscrizione per l'attività?";
    }
    if (confirm(message)) {
      user
        .dispatchChangeStatusPeriodoIscrizioneAttivita(this["$store"], payload)
        .then(() => {
          bus.$emit(
            "successfullOperation",
            "Stato periodo di iscrizione modificato con successo"
          );
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    }
  }

  modificaPubblicazione(value: any, attività: any) {
    var message: string = "";
    var payload = {
      idAttivita: attività.idAttivita,
      statoPubblicazione: value
    };
    if (value === true) {
      message = "Si desidera pubblicare le schedulazioni dei colloqui CV?";
    } else {
      message = "Si desidera nascondere le schedulazioni dei colloqui CV?";
    }
    if (confirm(message)) {
      user
        .dispatchChangeStatusPubblicazioneAttivita(this["$store"], payload)
        .then(() => {
          bus.$emit(
            "successfullOperation",
            "Stato pubblicazione modificato con successo"
          );
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    }
  }

  changeAnnoScolastico() {
    bus.$emit("changeAnnoScolastico", this.annoScolasticoFilter);
  }

  loadAnniScolastici() {
    data
      .dispatchAnniScolastici(this["$store"])
      .then(result => {
        result.forEach((element: any) => {
          this.anniScolastici.push({
            //@ts-ignore
            nomeAnno: element.nomeAnnoScolastico,
            //@ts-ignore
            idAnno: element.idAnnoScolastico
          });
        });
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  created() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);

    this.loadAnniScolastici();
    this.annoScolasticoFilter = idAnnoScolastico;

    bus.$on("dataLoaded", () => {
      this.loadingData = false;
    });
  }
}
